/* eslint-disable @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars */
import { Defaults } from './types/config';

/**
 * A stub {@link Client} implementation that does nothing for all methods
 */
export class StubExperimentClient {
  getUser() {
    return {};
  }

  async start(_user) {
    return;
  }

  stop() {}

  setUser(_user) {}

  async fetch(_user) {
    return this;
  }

  getUserProvider() {
    return null;
  }

  setUserProvider(_userProvider) {
    return this;
  }

  variant(_key, _fallback) {
    return Defaults.fallbackVariant;
  }

  all() {
    return {};
  }

  clear() {}

  exposure(_key) {}

}
//# sourceMappingURL=stubClient.js.map